// import React from 'react';
// import { motion } from 'framer-motion';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './RealEstateErp.css'; 

// const containerVariants = {
//   hidden: { opacity: 0 },
//   visible: {
//     opacity: 1,
//     transition: {
//       staggerChildren: 0.1,
//     },
//   },
// };

// const letterVariants = {
//   hidden: { opacity: 0, y: 50 },
//   visible: {
//     opacity: 1,
//     y: 0,
//     transition: {
//       type: 'spring',
//       stiffness: 50,
//     },
//   },
// };

// const SolventExtractionErp = () => {
//   return (
//     <div className="container text-center d-flex flex-column justify-content-center align-items-center comingSooncontainer">
//       <h1 className='erp-heading'>Solvent Extraction ERP</h1>
      


//       <motion.div
//         initial="hidden"
//         animate="visible"
//         variants={containerVariants}
//         className="mb-10"
//       >
//         {/* {'Coming Soon'.split('').map((letter, index) => (
//           <motion.span key={index} variants={letterVariants} className="display-1">
//             {letter}
//           </motion.span>
//         ))} */}
//         <iframe src="https://lottie.host/embed/b46d86b1-7742-403e-a0cf-a7de01aaecf1/GBLeYf49xf.json" className='comingSoonIframe'></iframe>
//       </motion.div>
//       <motion.div
//         initial={{ opacity: 0, y: 50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 1, type: 'spring', stiffness: 50 }}
//         className="lead"
//       >
//         Stay tuned, we appreciate your patience.
//       </motion.div>
//     </div>
//   );
// }

// export default SolventExtractionErp


import React from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SolventExtractionErp.css";
import { FaSeedling, FaIndustry, FaOilCan, FaWarehouse, FaTruck } from "react-icons/fa";
import { GiOilDrum } from "react-icons/gi";

const SolventExtractionErp = () => {
  const features = [
    { icon: FaSeedling, title: "Raw Material Management", desc: "Track procurement and storage of seeds like soybean, sunflower, mustard, and cottonseed." },
    { icon: FaIndustry, title: "Extraction Plant Monitoring", desc: "Monitor solvent extraction process, efficiency, and machine performance in real time." },
    { icon: FaOilCan, title: "Oil Production Tracking", desc: "Track crude oil batches, refining, and oil yield with precise records." },
    { icon: FaWarehouse, title: "Inventory & Storage", desc: "Manage chemicals, seeds, packaging materials, and finished oil stock." },
    { icon: FaTruck, title: "Packaging & Logistics", desc: "Plan dispatch, packaging, and track deliveries efficiently." },
    { icon: GiOilDrum, title: "Reports & Analytics", desc: "Generate production, inventory, and financial reports for better decisions." },
  ];

  const workflowSteps = [
    { icon: FaSeedling, label: "Seed Cleaning" },
    { icon: FaIndustry, label: "Seed Crushing / Flaking" },
    { icon: FaOilCan, label: "Solvent Extraction" },
    { icon: GiOilDrum, label: "Oil Refining" },
    { icon: FaWarehouse, label: "Storage" },
    { icon: FaTruck, label: "Packaging & Dispatch" },
  ];

  return (
    <div className="landing-page">
      {/* HERO */}
      <section className="landing-hero d-flex flex-column flex-md-row align-items-center">
        <div className="container hero-text text-center text-md-start">
          <motion.h1 initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
            Solvent Extraction & Edible Oil ERP
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9 }}>
            Complete ERP solution for edible oil plants. Manage procurement, production, inventory, refining, packaging, and logistics efficiently.
          </motion.p>
          {/* <motion.button className="btn demo-btn mt-3" initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }}>
            Request Demo
          </motion.button> */}
        </div>
        <div className="hero-image text-center mt-4 mt-md-0">
          <img
            src="https://images.unsplash.com/photo-1606303855950-5c4b1d41e5f7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=800"
            alt="Industrial Oil Plant"
          />
        </div>
      </section>

      {/* FEATURES */}
      <section className="features-section container my-5">
        <h2 className="section-title text-center mb-5">ERP Modules</h2>
        <div className="row">
          {features.map((f, idx) => (
            <motion.div key={idx} className="col-md-4 mb-4" whileHover={{ y: -10 }}>
              <div className="feature-card text-center">
                <div className="feature-icon"><f.icon size={40} color="#27ae60" /></div>
                <h5>{f.title}</h5>
                <p>{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* WORKFLOW */}
      <section className="workflow-section container my-1">
        <h2 className="section-title text-center mb-4">Plant Workflow</h2>
        <div className="workflow-container d-flex flex-wrap justify-content-between align-items-center">
          {workflowSteps.map((step, idx) => (
            <div key={idx} className="workflow-step text-center mb-3">
              <div className="workflow-icon mb-2"><step.icon size={40} color="#27ae60" /></div>
              <div className="workflow-label">{step.label}</div>
              {idx !== workflowSteps.length - 1 && <div className="workflow-arrow">→</div>}
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section text-center my-5">
        <h2>Transform Your Oil Processing Operations</h2>
        <p>Manage all aspects of solvent extraction and edible oil production with one integrated ERP system.</p>
        {/* <button className="btn demo-btn">Request Demo</button> */}
      </section>
    </div>
  );
};

export default SolventExtractionErp;